
import Vue from 'vue'
import { mixins } from 'cms3-shop-module-ts'

export default Vue.extend({
  mixins: [mixins.UiSelect],

  props: {
    /**
     * * fetch функция
     */
    fetch: {
      type: Function,
      required: false,
      default: undefined
    },

    /**
     * * Опции
     */
    option: {
      type: Object,
      required: true,
      default: () => {}
    },
    options: {
      type: Array,
      required: false,
      default: () => []
    },

    /**
     * * Заголовок
     */
    title: {
      type: String,
      required: true,
      default: ''
    },

    /**
     * * Обязательность поля
     */
    required: {
      type: Boolean,
      required: false,
      default: () => false
    },

    /**
     * * Сообщение что значений не найдено
     */
    notFoundMsg: {
      type: String,
      default: undefined
    },

    /**
     * * Название поля для отображения элементов списка
     */
    optionsFieldPath: {
      type: String,
      required: true,
      default: 'value'
    },

    /**
     * * Название поля для отображения текущего элемента списка
     */
    optionFieldPath: {
      type: String,
      required: true,
      default: 'value'
    },

    placeholder: {
      type: String,
      default: () => ''
    },

    staticClass: {
      type: String,
      default: () => ''
    }
  }
})
